import { render } from "./AlertCard.vue?vue&type=template&id=708201f6&scoped=true"
import script from "./AlertCard.vue?vue&type=script&lang=js"
export * from "./AlertCard.vue?vue&type=script&lang=js"

import "./AlertCard.vue?vue&type=style&index=0&id=708201f6&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708201f6"]])

export default __exports__